import { AccentColor } from '@typings/index'
import useLocalStorage from './useLocalStorage'

export const useAccentColor = () => {
  return useLocalStorage<AccentColor>('accentColor', 'lightBlue')
}

export const accentColorConfig = {
  lightBlue: {
    primary: 'bg-[#A2E9FE] text-black',
    hover: 'hover:bg-[#91E3FC]',
    text: 'text-[#A2E9FE]',
    border: 'border-[#A2E9FE]',
    light: 'bg-[#E4F8FF]',
    lightHover: 'hover:bg-[#D5F4FF]',
    darkHeader: 'bg-[#E4F8FF] dark:bg-gray-800',
    hexa: '#A2E9FE',
  },
  navyBlue: {
    primary: 'bg-[#1E2C72]',
    hover: 'hover:bg-[#1A2663]',
    text: 'text-[#1E2C72]',
    border: 'border-[#1E2C72]',
    light: 'bg-[#D5DBF5]',
    lightHover: 'hover:bg-[#BFC9F0]',
    darkHeader: 'bg-[#D5DBF5] dark:bg-gray-800',
    hexa: '#1E2C72',
  },
  yellow: {
    primary: 'bg-[#F8C024] text-black',
    hover: 'hover:bg-[#F5B118]',
    text: 'text-[#F8C024]',
    border: 'border-[#F8C024]',
    light: 'bg-[#FFF3D1]',
    lightHover: 'hover:bg-[#FFEBC2]',
    darkHeader: 'bg-[#FFF3D1] dark:bg-gray-800',
    hexa: '#F8C024',
  },
  green: {
    primary: 'bg-[#7DB928] text-black',
    hover: 'hover:bg-[#71A723]',
    text: 'text-[#7DB928]',
    border: 'border-[#7DB928]',
    light: 'bg-[#EDF5DA]',
    lightHover: 'hover:bg-[#E6F1CC]',
    darkHeader: 'bg-[#EDF5DA] dark:bg-gray-800',
    hexa: '#7DB928',
  },
  limeGreen: {
    primary: 'bg-[#D7FF70] text-black',
    hover: 'hover:bg-[#C7F966]',
    text: 'text-[#D7FF70]',
    border: 'border-[#D7FF70]',
    light: 'bg-[#F3FFD4]',
    lightHover: 'hover:bg-[#E7FFBF]',
    darkHeader: 'bg-[#F3FFD4] dark:bg-gray-800',
    hexa: '#D7FF70',
  },
}
